// Short summaries keep the homepage useful; fuller information lives on each practice page.
export const practiceSummaries: Record<string, string> = {
  tarot: "Explore love, work or a personal decision through an audio call or voice note.",
  reiki: "A gentle energy practice for relaxation and reflection. Single sessions or a five-session package.",
  "relationship-healing": "Explore communication, trust and recurring disagreements, individually or with your partner.",
  "hanuman-healing": "A devotional practice centred on spiritual protection, grounding and inner strength.",
  "maha-kali-healing": "Guided spiritual reflection on emotional shadows, attachments and repeating patterns.",
  "maa-kamakhya-healing": "A Shakti-centred practice with intentions chosen around your personal concerns.",
  "tarot-spells": "Personal rituals for love, career, protection and more. Choose one day, seven days or a custom ritual.",
  "past-life": "Explore recurring themes through guided relaxation, starting with a conversation about suitability.",
  "mobile-number-correction": "A personal numerology report exploring your phone number alongside your date of birth.",
  therapy: "A private conversation about emotions, everyday challenges and your next steps.",
  "courses/tarot": "A 16-day curriculum, live or recorded, with reading practice and a completion certificate.",
  "courses/healing-oils-course": "Learn oils, sprays and rituals across nine modules in a two-day certificate course.",
  numerology: "Life path, name numerology and compatibility readings are being prepared.",
};

interface PracticeGuide {
  title: string;
  introduction: string;
  items: { title: string; text: string }[];
}
export const practiceGuides: Record<string, PracticeGuide> = {
  tarot: {
    title: "A reading around your questions.",
    introduction: "Choose a question-based reading for a specific concern, or a timed session when you have more to explore.",
    items: [
      { title: "Questions or time", text: "Choose one to five questions, or a session lasting 5–45 minutes. The five-question option includes angel guidance." },
      { title: "Audio call or voice note", text: "Select your preferred format when booking. Each booking covers one person and one type of spread." },
    ],
  },
  reiki: {
    title: "A closer look at Reiki.",
    introduction: "Reiki is a Japanese energy practice. At Radian Soul, it offers a quiet space for relaxation and personal reflection.",
    items: [
      { title: "Space to slow down", text: "Bring your intention for the session, whether that is rest, emotional reflection or reconnecting with yourself." },
      { title: "One session or ongoing practice", text: "Choose a 30- or 60-minute session, or explore a five-session package. Ask Vaanii about the format and preparation before you book." },
    ],
  },
  "relationship-healing": {
    title: "More room for understanding.",
    introduction: "Sessions explore the patterns behind emotional distance and repeated disagreements, with practical communication and reflection exercises.",
    items: [
      { title: "Recognise the pattern", text: "Explore triggers, emotional needs and the conversations that tend to repeat. You can attend alone to focus on your own experience." },
      { title: "Practise a different conversation", text: "Work on listening without escalation, expressing needs clearly and finding ways to reconnect after disagreements. Couple sessions involve both partners." },
    ],
  },
  therapy: {
    title: "A conversation at your pace.",
    introduction: "A private, non-judgmental space to share what you are experiencing and explore what matters to you.",
    items: [
      { title: "What you can bring", text: "Everyday stress, relationship concerns, difficult emotions or questions about personal growth. You do not need to arrive with a neatly defined problem." },
      { title: "Make space for reflection", text: "Choose a single 30- or 60-minute conversation, or a package for continued support. Discuss your needs with Vaanii before choosing." },
    ],
  },
  "mobile-number-correction": {
    title: "What’s inside your report?",
    introduction: "A numerology-based interpretation of your number and birth date. Your report is shared on WhatsApp within 24–48 hours.",
    items: [
      { title: "Number patterns & charts", text: "Lo-Shu Grid, Vedic Grid and Dasha Chart, alongside a phone-number interpretation and a recommended total sum." },
      { title: "Personal recommendations", text: "Numbers and colours interpreted as favourable or unfavourable in numerology, traditional remedies for missing numbers and personal affirmations." },
      { title: "Compare your options", text: "Choose a report for one phone number, two personal numbers or a bundle of four numbers." },
    ],
  },
  "courses/tarot": {
    title: "From learning the cards to reading them.",
    introduction: "Start with the foundations and build towards practical readings. The original 16-day curriculum is included below, with a certificate on successful completion.",
    items: [
      { title: "Live learning", text: "Interactive Google Meet sessions with opportunities to ask questions and practise readings in real time. You can request a demo before enrolling." },
      { title: "Recorded learning", text: "Self-paced lessons with lifetime access to the recordings. Course access details are shared on WhatsApp within 24–48 hours." },
    ],
  },
  "courses/healing-oils-course": {
    title: "Ingredients, preparation & personal rituals.",
    introduction: "A practical introduction to making oils and sprays, followed by ways to use them in traditional rituals. The full nine-module outline is below.",
    items: [
      { title: "Begin with the ingredients", text: "Explore base oils, essential oils, herbs, spices and crystals, then learn how they are used in traditional preparations." },
      { title: "Build your own practice", text: "Continue into sprays, intention-setting rituals, numerology baths and oil application across a two-day certificate course." },
    ],
  },
};
